export const BEMOB_URL = 'https://www.sweepmob.com/click'
export const BINOM_URL = 'http://tracker.sweepmob.com/c1kgl9k.php?lp=1'
export const BEMOB_URL_Empty = ''
export const AFFISE_URL = 'https://www.sweepmob.com/click?sub3=yvonne.steinert021@gmail.com&sub4=Yvonbe&sub5=Steiner&sub6=02&sub7=12&sub8=1979&city=New+York'
export const EMAIL_VERIFICATION_URL = 'https://emailvalidation.abstractapi.com/v1/?api_key=4d10af42adcb45b2999409b14f4de5f8'

// Tracker X appends ?txclk=<click id> to lander URLs. While Binom is being retired both trackers
// send traffic here, so the click decides where the offer click goes.
export const TRACKER_X_URL = 'https://go.exceliadigital.com'

// Remember the Tracker X click for this tab; a lander visit without it is Binom traffic.
export const captureTxClick = () => {
  try {
    const txclk = new URLSearchParams(window.location.search).get('txclk')
    if (txclk) sessionStorage.setItem('txclk', txclk)
    else sessionStorage.removeItem('txclk')
  } catch {
    // storage blocked: getTxClick still reads the URL
  }
}

export const getTxClick = () => {
  const fromUrl = new URLSearchParams(window.location.search).get('txclk')
  if (fromUrl) return fromUrl
  try {
    return sessionStorage.getItem('txclk')
  } catch {
    return null
  }
}

// Base of the lander → offer click; callers append &event1=<email>... like they did to BINOM_URL.
export const offerClickBase = () => {
  const txclk = getTxClick()
  return txclk ? `${TRACKER_X_URL}/lp?txclk=${encodeURIComponent(txclk)}` : BINOM_URL
}
